
    <h1 mat-dialog-title class="text-center mb-3">What Counts as a Bedroom?</h1>
    <div mat-dialog-content style="font-size: 1.05em; color: #424242;">
      <p><strong>1. Solid door with lock</strong> (if the plans say the door is "non-locking" or
        &ldquo;non-latching&rdquo; then it does not meet this criteria. If the plans do not specify,
        we assume it has a lock. No glass door meets this criteria, the door must be solid.)</p>

      <p><strong>2. At least one operable/egress window</strong> (if the only window(s) present in
        this room are fixed, the criteria is not met. If all the windows are fixed, but there is a
        door opening to the exterior present, the criteria is met since it provides egress in an
        emergency).</p>

      <p><strong>3. Minimum area of 70 sq.ft.</strong></p>

      <p><strong>4. Closet</strong> (any size).</p>

      <p style="margin-top: 1.25em;"><strong>Instructions:</strong> If the bedroom count is correct,
        please verify. If you are sure that the bedroom count is incorrect, please select incorrect
        and override the count. If you are unsure of the count because of a certain confusing
        feature, please mark unsure and override the value if necessary, or contact the office or
        reviewer for confirmation. Please do not subtract a bedroom if you are unsure, only ADD by
        no more than 1. You may also want to leave a rater note. Note that the ventilation
        calculation is based on bedroom/occupant counts. If you under estimate, you will be setting
        the controller to a runtime LESS than is allowed by ASHRAE. If you over estimate, you will
        only be adding a little more ventilation (7.5cfm per BR), but too little could result in a
        model failure.</p>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <button mat-button color="primary" (click)="dialogRef.close()">Close</button>
    </div>
  